'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('remodal');

var init = function init(options) {
  $('[data-remodal-id]').remodal(options);
};

exports.default = {
  init: init
};